import React, { useMemo } from "react";
import { useGameStateStore } from "../../stores/gameStateStore";
import "./NumberTable.css";



type TableBallProps = {
  number: number;
  isPicked: boolean;
}


export default function NumberTable() {
  const numbers = Array(90).fill("").map((a, aI) => aI + 1);
  const pickedNumbers = useGameStateStore(s => s.pickedNumbers);
  const pickedSet = useMemo(() => new Set(pickedNumbers), [pickedNumbers]);

  return (
    <div className="number-table">
      <div className="number-table-header">
        <span className="number-table-header-text">Numbers</span>
        <span className="number-table-detail">
          <i className="fa-solid fa-right-left number-table-header-icon"></i>
          <span className="number-table-header-ball-length">{pickedNumbers.length}/90</span>
        </span>
      </div>
      <div className="number-table-body">
        {numbers.map((number) => (
          <TableBall
            key={`number-table-${number}`}
            number={number}
            isPicked={pickedSet.has(number)}
          />
        ))}
      </div>
    </div>
  );
}



const TableBall = React.memo(function TableBall({ number, isPicked }: TableBallProps) {
  return (
    <div className="table-ball">
      <div className={`number-ball ${isPicked ? "" : "no-"}picked-number-ball`}>
        <span>{number}</span>
      </div>
    </div>
  );
});
